import React from 'react';
import { Button, ButtonSize, ButtonType } from '@bimone/bimtrackreactcomponents';
import { useAuth } from 'react-oidc-context';
import { useErrorHandler } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { StyledLoginPage } from './styles';

interface Props {
  state?: { from?: string };
}

export default function LoginPage({ state }: Props): JSX.Element {
  const { Container, LogoIcon } = StyledLoginPage;
  const { signinRedirect } = useAuth();
  const setError = useErrorHandler();
  const { t } = useTranslation('loginPage');

  const handleOnClickSignInButton = async (): Promise<void> => {
    try {
      await signinRedirect({ state });
    } catch (error) {
      setError(error);
    }
  };

  return (
    <Container>
      <LogoIcon />
      <Button
        label={t('signIn') ?? ''}
        onClick={handleOnClickSignInButton}
        size={ButtonSize.LARGE}
        type={ButtonType.PRIMARY}
      />
    </Container>
  );
}
